import Graphics from 'core/display/Graphics'
import { signal } from 'services/SignalsService'

export default class SpinSwipeButton {
  constructor(data) {
    this.self = new Graphics(data)
    this.intial = 0
    this.TRIGGER = 50

    return this.self
  }

  start({ y }) {
    this.intial = y
  }

  stop({ y }) {
    Math.abs(y - this.intial) > this.TRIGGER && signal.dispatch('BUTTON:spin')
  }
}
